import { render, staticRenderFns } from "./employer-list.vue?vue&type=template&id=7d8d6e44&scoped=true"
import script from "./employer-list.vue?vue&type=script&lang=ts"
export * from "./employer-list.vue?vue&type=script&lang=ts"
import style0 from "./employer-list.vue?vue&type=style&index=0&id=7d8d6e44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8d6e44",
  null
  
)

export default component.exports